import { useEffect, useState } from "react";
import axios from "../../../../shared/config/axios-interceptor";

interface Props {
  gameId?: string;
  load: boolean;
}
const LichSuPhien = ({ gameId, load }: Props) => {
  const [histories, setHistories] = useState<any[]>([]);
  const getGame = async () => {
    try {
      if (gameId) {
        const res = await axios.get(
          "/draws?status=DONG&sortOrder=DESC&sortBy=id&limit=6&gameId=" + gameId
        );
        setHistories(res?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGame();
  }, [load, gameId]);

  return (
    <div className="h-100 pt-4 lich-su-phien">
      <div
        className="h-100 p-3 py-4 rounded-2 position-relative"
        style={{ background: "rgb(7, 15, 33)" }}
      >
        <div className="position-relative">
          <h6
            className="text-center pb-3 mb-0"
            style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}
          >
            Lịch sử phiên
          </h6>

          {histories?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="d-flex py-2 align-items-center"
                style={{
                  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                  fontSize: 14,
                }}
              >
                <div
                  className="text-center"
                  style={{ width: 65, flexShrink: 0 }}
                >
                  #{item?.id}
                </div>
                <div
                  className="fw-bold"
                  style={{ width: "100%", flexShrink: 0, color: "rgb(255, 0, 0)" }}
                >
                  {item?.ketQua} - {item?.ketQua1} - {item?.ketQua2} -{" "}
                  {item?.ketQua3}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LichSuPhien;
